import { render, staticRenderFns } from "./SelectCategoriesPage.vue?vue&type=template&id=4db7be96&scoped=true&"
import script from "./SelectCategoriesPage.vue?vue&type=script&lang=js&"
export * from "./SelectCategoriesPage.vue?vue&type=script&lang=js&"
import style0 from "./SelectCategoriesPage.vue?vue&type=style&index=0&id=4db7be96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db7be96",
  null
  
)

export default component.exports